export const ALL_SWAG_CATEGORY_LABEL = 'Quality Custom Branded Merchandise';